import { cn } from '@/lib/utils'

/**
 * The JWA wordmark — the app's one piece of brand identity, and the ONLY place
 * it is drawn (auth pages, desktop sidebar, narrow header, mobile header).
 *
 * Brushed metal: graphite in light mode, silver in dark, with a bright band
 * through the middle. The colours are the `--brand-mark-*` tokens, defined in
 * `:root` and `.dark` only so no palette can recolour the brand.
 *
 * Every var() carries a literal fallback. A bare var() whose token is missing
 * is an invalid value, the browser drops the whole declaration, and
 * text-transparent then leaves the mark INVISIBLE with no error anywhere — the
 * SOLO mark shipped exactly that way on 2026-09-01. The fallbacks are the
 * light values: a degraded mark is dark grey, which reads on either ground.
 */
const METAL_GRADIENT =
  'linear-gradient(135deg, var(--brand-mark-from, #18181b) 0%, var(--brand-mark-shine, #71717a) 50%, var(--brand-mark-to, #3f3f46) 100%)'

export function JwaWordmark({ className }: { className?: string }) {
  return (
    <span
      className={cn('bg-clip-text font-bold tracking-tight text-transparent', className)}
      style={{ backgroundImage: METAL_GRADIENT }}
    >
      JWA
    </span>
  )
}
